import { createFileRoute } from '@tanstack/react-router';
import { VisitListPage } from '@/modules/visit-list/visit-list-page';

/**
 * `?visitId=` mirrors the legacy `?VisitID=` deep link other modules use to
 * jump straight to one visit.
 *
 * `?f=` is the encoded filter selection. The filters module writes it with
 * `history.replaceState`, but it still has to be declared here — otherwise a
 * router navigation would validate it away and drop the user's filters.
 */
interface VisitListSearch {
  visitId?: string;
  f?: string;
}

export const Route = createFileRoute('/_auth/visit-list')({
  validateSearch: (search: Record<string, unknown>): VisitListSearch => ({
    visitId: typeof search.visitId === 'string' ? search.visitId : undefined,
    f: typeof search.f === 'string' ? search.f : undefined,
  }),
  component: VisitListRoute,
});

function VisitListRoute() {
  const { visitId } = Route.useSearch();
  return <VisitListPage visitId={visitId} />;
}
